<script lang="ts">
  let {
    label,
    items,
    selected,
    onChange,
  }: {
    label: string;
    items: ReadonlyArray<{ id: string; label: string }>;
    selected: readonly string[];
    onChange: (next: string[]) => void;
  } = $props();

  let search = $state('');
  let visibleItems = $derived(
    items.filter((item) =>
      item.label.toLocaleLowerCase('it').includes(search.toLocaleLowerCase('it')),
    ),
  );
  let selectedSet = $derived(new Set(selected));

  function toggle(id: string): void {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    onChange(Array.from(next));
  }

  function selectVisible(): void {
    onChange(Array.from(new Set([...selected, ...visibleItems.map((item) => item.id)])));
  }

  function clearVisible(): void {
    const visible = new Set(visibleItems.map((item) => item.id));
    onChange(selected.filter((id) => !visible.has(id)));
  }
</script>

<fieldset class="multi-select">
  <legend>
    <span>{label}</span><span class="selection-count">{selected.length} / {items.length}</span>
  </legend>
  <label class="search-field compact-field">
    <span class="sr-only">Cerca in {label}</span>
    <input
      bind:value={search}
      type="search"
      placeholder={`Cerca ${label.toLocaleLowerCase('it')}`}
    />
  </label>
  <div class="select-actions">
    <button type="button" onclick={selectVisible}>Seleziona {visibleItems.length} risultati</button>
    <button type="button" onclick={clearVisible}>Deseleziona risultati</button>
  </div>
  <div class="checkbox-list">
    {#each visibleItems as item (item.id)}
      <label>
        <input
          type="checkbox"
          checked={selectedSet.has(item.id)}
          onchange={() => toggle(item.id)}
        />
        <span>{item.label}</span>
      </label>
    {:else}
      <p class="muted">Nessun elemento corrispondente.</p>
    {/each}
  </div>
</fieldset>
